
import { useRef,useEffect } from "react";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import plusIcon from "../../../assets/plusIcon.png";
import styles from "./CreateCustomer.module.css";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";
import dummyImg from "../../../assets/dummy.png";
import { IMG_URL } from "../../../store/Apis";
import { SearchInput } from "../../../components";

const CreateCustomer = () => {
  const navigate = useNavigate();
  const timeout = useRef(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const CreateCustomerList = useSelector(
    (state) => state.CustomerReducer.CreateCustomerList
  );
  const CreateCustomerPagination = useSelector(
    (state) => state.CustomerReducer.CreateCustomerPagination
  );

  useEffect(() => {
    getCreateCustomer();
    getLanguage();
  }, []);

  const getCreateCustomer = () => {
    const data = {
      next_page_url: undefined,
    };
    dispatch(CustomerMiddleware.getCreateCustomer(data));
  };

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const onPressLoadMore = () => {
    let data = {
      next_page_url: CreateCustomerPagination?.links?.next,
    };
    dispatch(CustomerMiddleware.getCreateCustomer(data));
  };

  const onSearchCustomer = text => {
    let data = {
        search: text,
        next_page_url: undefined
    };
    // setSearch(text);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
        dispatch(CustomerMiddleware.getCreateCustomer(data));
    }, 1000);
};

  const loadMore = CreateCustomerPagination?.links?.next ? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        height: 32,
        lineHeight: "32px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button onClick={onPressLoadMore} className={styles.loadMore_button}>
        Load More
      </button>
    </div>
  ) : null;

  const renderItem = (item) => {
    console.log("item", item);
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/contractorHome/Customer", {
            state: item,
          })
        }
      >
        <img
          src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg}
          className={styles.image}
        />
        <div className={styles.heading_view}>
          <text className={styles.tab_heading}> {item?.name}</text>
          <text className={styles.text}>Customer</text>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className={styles.mainCon}>
        <div className={styles.filterItem}>
          <SearchInput onChange={(e) => onSearchCustomer(e.target.value)} placeholder={"Search"} containerStyle={{ width: '50%',marginBottom:30 }} />
        </div>
        <List
          style={{ width: "100%" }}
          grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
          dataSource={CreateCustomerList}
          footer={loadMore}
          renderItem={renderItem}
        />
      </div>
      <div className={styles.plusImg}>
        <img
          onClick={() => navigate("/contractorHome/CreateNewCustomer")}
          src={plusIcon}
        />
      </div>
    </>
  );
};
export default CreateCustomer;
